import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MoneyTransaction  {
    _originalTypeClassName = "zERP.BO.MoneyTransaction";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MoneyTransaction.translate = translateService;
}
this.Id = null;
this.Amount = null;
this.Description = null;
this.CreatedAt = null;
this.OriginDocument = null;
this.OriginDocumentId = null;
this.Reference = null;
this.Type = null;
this.UpdatesAccounts = false;
this.UpdateAccountsDate = null;
this.IsFinalized = false;
this.FinalizedAt = null;
this.FromType = null;
this.ToType = null;
this.FromOther = null;
this.ToOther = null;
this.SeriesCode = null;
this.MappedWithAccounting = false;
this.ExternalSourceId = null;
this.SyncDate = null;
this.SeriesAndCodeStr = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Amount:any;
Description:any;
CreatedAt:any;
OriginDocument:any;
OriginDocumentId:any;
Reference:any;
Type:any;
UpdatesAccounts:any;
UpdateAccountsDate:any;
IsFinalized:any;
FinalizedAt:any;
FromType:any;
ToType:any;
FromOther:any;
ToOther:any;
SeriesCode:any;
MappedWithAccounting:any;
ExternalSourceId:any;
SyncDate:any;
SeriesAndCodeStr:any;
FromBankAccount:any;
FromCashAccount:any;
ToBankAccount:any;
ToCashAccount:any;
Check:any;
TransactionEntity:any;
Entity:any;
Series:any;
Cashier:any;
static setFromBankAccount = ($this, value) => {
var oldValue = $this.FromBankAccount;
$this.FromBankAccount = value;
if (value != null) {
}
}
static setFromCashAccount = ($this, value) => {
var oldValue = $this.FromCashAccount;
$this.FromCashAccount = value;
if (value != null) {
}
}
static setToBankAccount = ($this, value) => {
var oldValue = $this.ToBankAccount;
$this.ToBankAccount = value;
if (value != null) {
}
}
static setToCashAccount = ($this, value) => {
var oldValue = $this.ToCashAccount;
$this.ToCashAccount = value;
if (value != null) {
}
}
static setCheck = ($this, value) => {
var oldValue = $this.Check;
$this.Check = value;
if (value != null) {
if (oldValue != null && oldValue.MoneyTransaction != null) { oldValue.MoneyTransaction = null; }
if ($this.Check.MoneyTransaction !== $this) {
Domain.Check.setMoneyTransaction(value, $this);
}
}
}
static setTransactionEntity = ($this, value) => {
var oldValue = $this.TransactionEntity;
$this.TransactionEntity = value;
if (value != null) {
}
}
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setSeries = ($this, value) => {
var oldValue = $this.Series;
$this.Series = value;
if (value != null) {
}
}
static setCashier = ($this, value) => {
var oldValue = $this.Cashier;
$this.Cashier = value;
if (value != null) {
}
}

static CreateDeposit(entity: any,transactionEntity: any,fromCashAccount: any,toBankAccount: any,amount: any,docType: any,docId: any,refText: any): any{let trns = Domain.MoneyTransaction.Init(entity, transactionEntity, moment().toDate(), amount, docType, docId, refText);
Domain.MoneyTransaction.setFromCashAccount(trns, fromCashAccount);
trns.FromType = Domain.MoneyAccountType.Cash;
Domain.MoneyTransaction.setToBankAccount(trns, toBankAccount);
trns.ToType = Domain.MoneyAccountType.Bank;
trns.IsFinalized = false;
trns.UpdatesAccounts = false;
return trns;
}
static CreateOutboundCheck(entity: any,transactionEntity: any,check: any,amount: any,docType: any,docId: any,refText: any): any{let trns = Domain.MoneyTransaction.Init(entity, transactionEntity, moment().toDate(), amount, docType, docId, refText);
Domain.MoneyTransaction.setFromBankAccount(trns, check?.BankAccount);
Domain.MoneyTransaction.setToBankAccount(trns, null);
trns.FromType = Domain.MoneyAccountType.Bank;
trns.ToType = Domain.MoneyAccountType.Other;
Domain.MoneyTransaction.setCheck(trns, check);
trns.IsFinalized = false;
trns.UpdatesAccounts = false;
return trns;
}
static CreateTransfer(entity: any,transactionEntity: any,fromBankAccount: any,toBankAccount: any,amount: any,docType: any,docId: any,refText: any): any{let trns = Domain.MoneyTransaction.Init(entity, transactionEntity, moment().toDate(), amount, docType, docId, refText);
Domain.MoneyTransaction.setFromBankAccount(trns, fromBankAccount);
trns.FromType = Domain.MoneyAccountType.Bank;
Domain.MoneyTransaction.setToBankAccount(trns, toBankAccount);
trns.ToType = Domain.MoneyAccountType.Bank;
trns.IsFinalized = false;
trns.UpdatesAccounts = false;
return trns;
}
static CreateWithdraw(entity: any,transactionEntity: any,fromBankAccount: any,toCashAccount: any,amount: any,docType: any,docId: any,refText: any): any{let trns = Domain.MoneyTransaction.Init(entity, transactionEntity, moment().toDate(), amount, docType, docId, refText);
Domain.MoneyTransaction.setFromBankAccount(trns, fromBankAccount);
trns.FromType = Domain.MoneyAccountType.Bank;
Domain.MoneyTransaction.setToCashAccount(trns, toCashAccount);
trns.ToType = Domain.MoneyAccountType.Cash;
trns.IsFinalized = false;
trns.UpdatesAccounts = false;
return trns;
}
static DestinationCurrency($this: any): any{switch (($this?.ToType)) {case Domain.MoneyAccountType.Bank:
{
if ($this?.ToBankAccount != null && !(Domain.BankAccount.IsNew($this?.ToBankAccount)) && $this?.ToBankAccount?.Currency == null) {throw Error(this.translate.instant('BankingBO_RES_MISSING_CURRENCY') + " " + $this?.ToBankAccount?.Name);}return $this?.ToBankAccount?.Currency;}
case Domain.MoneyAccountType.Cash:
{
if ($this?.ToCashAccount != null && !(Domain.CashAccount.IsNew($this?.ToCashAccount)) && $this?.ToCashAccount?.Currency == null) {throw Error(this.translate.instant('BankingBO_RES_MISSING_CURRENCY') + " " + $this?.ToCashAccount?.Name);}return $this?.ToCashAccount?.Currency;}
default:
{
return null;}
}
}
static GetClassName(): any{return "MoneyTransaction";
}
static Init(entity: any,transactionEntity: any,date: any,amount: any,docType: any,docId: any,refText: any): any{let trns = new Domain.MoneyTransaction();
Domain.MoneyTransaction.setEntity(trns, entity);
Domain.MoneyTransaction.setTransactionEntity(trns, transactionEntity);
trns.CreatedAt = date;
trns.Amount = amount;
trns.OriginDocument = docType;
trns.OriginDocumentId = docId;
trns.Reference = refText;
return trns;
}
static IsCashTransaction($this: any): any{return $this?.FromType == Domain.MoneyAccountType.Cash || $this?.ToType == Domain.MoneyAccountType.Cash;
}
static SourceCurrency($this: any): any{switch (($this?.FromType)) {case Domain.MoneyAccountType.Bank:
{
if ($this?.FromBankAccount != null && !(Domain.BankAccount.IsNew($this?.FromBankAccount)) && $this?.FromBankAccount?.Currency == null) {throw Error(CLMS.Framework.String.Format("Δεν δηλώθηκε νόμισμα: {0}", $this?.FromBankAccount?.Name));}return $this?.FromBankAccount?.Currency;}
case Domain.MoneyAccountType.Cash:
{
if ($this?.FromCashAccount != null && !(Domain.CashAccount.IsNew($this?.FromCashAccount)) && $this?.FromCashAccount?.Currency == null) {throw Error(CLMS.Framework.String.Format("Δεν δηλώθηκε νόμισμα: {0}", $this?.FromCashAccount?.Name));}return $this?.FromCashAccount?.Currency;}
default:
{
return null;}
}
}
static UpdateSeriesAndCodeStr($this: any): any{let series = ($this?.Series != null ? $this?.Series?.Name : "");
let code = (CLMS.Framework.Number.NotEqual(() => $this.SeriesCode, () => null) && CLMS.Framework.Number.GreaterThan(() => $this.SeriesCode, () => 0) ? $this?.SeriesCode?.toString() : "");
$this.SeriesAndCodeStr = series + "-" + code;
}
static UpdateType($this: any): any{if ($this?.FromType == Domain.MoneyAccountType.Bank && $this?.ToType == Domain.MoneyAccountType.Bank) {$this.Type = Domain.MoneyTransactionType.Transfer;return;}
if ($this?.FromType == Domain.MoneyAccountType.Bank && $this?.ToType == Domain.MoneyAccountType.Cash) {$this.Type = Domain.MoneyTransactionType.Withdraw;return;}
if ($this?.FromType == Domain.MoneyAccountType.Cash && $this?.ToType == Domain.MoneyAccountType.Bank) {$this.Type = Domain.MoneyTransactionType.Deposit;return;}
if ($this?.FromType == Domain.MoneyAccountType.Other && $this?.ToType != Domain.MoneyAccountType.Other) {$this.Type = Domain.MoneyTransactionType.Collection;return;}
if ($this?.FromType != Domain.MoneyAccountType.Other && $this?.ToType == Domain.MoneyAccountType.Other) {$this.Type = Domain.MoneyTransactionType.Payment;return;}
$this.Type = Domain.MoneyTransactionType.Other;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}